var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.18861 19.0507C6.81947 19.4198 6.80189 20.079 7.1974 20.4657C7.58412 20.8524 8.2433 20.8436 8.61244 20.4745L13.9913 15.0868L19.379 20.4745C19.757 20.8524 20.4074 20.8524 20.7941 20.4657C21.172 20.0702 21.1808 19.4286 20.7941 19.0507L15.4152 13.663L20.7941 8.28407C21.1808 7.90614 21.1808 7.25575 20.7941 6.86903C20.3986 6.4911 19.757 6.48231 19.379 6.86024L13.9913 12.2479L8.61244 6.86024C8.2433 6.4911 7.57533 6.47352 7.1974 6.86903C6.81068 7.25575 6.81947 7.91493 7.18861 8.28407L12.5763 13.663L7.18861 19.0507Z",
    fill: "#2D2D2D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXmark);
export default __webpack_public_path__ + "static/media/xmark.a0c672f6bc7ddd4cfaf3bbeb36d9ede1.svg";
export { ForwardRef as ReactComponent };